import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface IntraCityState {
    activityList: ListWrap<IntraCity.ListItem> & ListRequesting;
    activityDetailMap: {
        [activityId: number]: IntraCity.Detail,
    };
}

const m: Module<IntraCityState, RootState> = {
    namespaced: true,
    state: () => ({
        activityList: {
            list: [],
            loaded: false,
            requesting: false,
        },
        activityDetailMap: {},
    }),
    mutations: {
        concatList(state, list) {
            state.activityList.list.push(...list);
        },
        setListLoaded(state, loaded) {
            state.activityList.loaded = loaded;
        },
        setListReq(state, req) {
            state.activityList.requesting = req;
        },
        setActivityDetailMap(state, { activityId, detail }: { activityId: number, detail: IntraCity.Detail }) {
            Vue.set(state.activityDetailMap, String(activityId), detail);
        },
    },
    actions: {
        /**
         * 获取同城活动列表
         * @param {} offset
         * @param {} count
         * @param {} forceUpdate
         */
        async getActivityList({ state, commit }, { offset,
        count, forceUpdate = false }) {
            const wrap = state.activityList;
            if (wrap.requesting || (wrap.loaded && !forceUpdate)) {
                return;
            }
            if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
            }
            const list = wrap.list;
            const end = offset + count;
            if (end <= list.length) {
                return;
            }
            if (offset < list.length) {
                offset = list.length;
                count = end - offset;
            }
            commit('setListReq', true);
            const response = await Vue.axios.get('/api/v1/city_activity/list', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('concatList', rdata.data);
                if (rdata.data.length < count) {
                    commit('setListLoaded', true);
                }
            }
            commit('setListReq', false);
            return rdata;
        },
        /**
         * 获取同城活动详情
         * @param {} activityId
         * @param {} forceUpdate
         */
        async getActivityDetail({ state, commit }, { activityId, forceUpdate = false }) {
            if (state.activityDetailMap[activityId] && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/city_activity/detail', {
                params: {
                    id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setActivityDetailMap', {
                    activityId,
                    detail: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 提交同城活动创建申请
         */
        async createActivity({ state, commit }, { cover, name, start_date, end_date, qr_code, description }) {
            const response = await Vue.axios.post('/api/v1/city_activity/create', {
                cover,
                name,
                start_date,
                end_date,
                qr_code,
                description,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
